//Serviços
import { Axios } from "../../service/serviceBasic";
import { toast } from "react-toastify";
import { setMessageConclusaoAction } from "../conclusao/actions";

// Tipos
import {
  SET_LOADING_RENOV_DOC,
  SET_DOCUMENTOS_RENOV_DOC,
  SET_TIPOS_DOCUMENTOS_RENOV_DOC,
  SET_TIPO_PESSOA,
  SET_TIPOS_DOC_OBRIGATORIOS_OPCIONAIS
} from "./types";

const setLoadingPage = (flag) => ({
  type: SET_LOADING_RENOV_DOC,
  payload: flag,
});

const setSolicitacoes = (object) => ({
  type: SET_DOCUMENTOS_RENOV_DOC,
  payload: object,
});

const setTiposDocumentoSolicitados = (list) => ({
  type: SET_TIPOS_DOCUMENTOS_RENOV_DOC,
  payload: list,
});

const setTipoPessoa = (payload) => ({
  type: SET_TIPO_PESSOA,
  payload,
});

const setTiposDocObrigatoriosOpcionais = (payload) => ({
  type: SET_TIPOS_DOC_OBRIGATORIOS_OPCIONAIS,
  payload,
});

export const listDocumentosSolicitadosAction = (idNotificacao, history) => dispatch => {

  dispatch(setLoadingPage(true));

  return Axios.get(`/v1/DocumentRenewal/${idNotificacao}`)
  .then(res => {
    if (res.data === null) {
      dispatch(
        setMessageConclusaoAction({
          icon: "fa-check-circle-o",
          title: "Os documentos solicitados já foram enviados!",
          email: "",
          discription:"",
          isError: false,
        })
      );
      history.push("/conclusao");
    } else {
      dispatch(setTiposDocumentoSolicitados(res.data.DocumentTypes.sort(x => {
        return res.data.Documents.find(y => y.CodigoProcam === x.Documentacao_Id).Obrigatorio ? 1 : -1;
      })));
      dispatch(setSolicitacoes(res.data.Documents));
      dispatch(setTipoPessoa(res.data.IdTipoPessoa));
  
      if (res.data.DocumentTypesRequiredOptionals && res.data.DocumentTypesRequiredOptionals.length > 0) {
        dispatch(setTiposDocObrigatoriosOpcionais(res.data.DocumentTypesRequiredOptionals));
      }
    }   
  })
  .catch((error) => {
    const errorMsg = error && error.response && error.response.data &&
    error.response.data.Message ? error.response.data.Message : "Ocorreu um erro. Tente novamente mais tarde.";
    
    toast.warn(errorMsg, {
      position: toast.POSITION.BOTTOM_RIGHT,
      className: "ui-alert-toast",
      bodyClassName: "ui-alert-toast-content",
    });
    history.push("/");
  })
  .finally(() => {
    dispatch(setLoadingPage(false));
  });  
}

export const enviarArquivos = (files, history) => dispatch => {

  dispatch(setLoadingPage(true));
  return Axios.post("/v1/DocumentRenewal", files)
  .then(res => {
    dispatch(
      setMessageConclusaoAction({
        icon: "fa-check-circle-o",
        title: "Documentos enviados com sucesso!",
        email: "",
        discription:"",
        isError: false,
      })
    );
    history.push("/conclusao");
  })
  .catch(error => {
    const errorMsg = error ? error.message : "Ocorreu um erro. Tente novamente mais tarde.";

    if (errorMsg.includes("Cliente não está com Status Pendente")) {
      dispatch(
        setMessageConclusaoAction({
          icon: "fa-check-circle-o",
          title: "Os documentos solicitados já foram enviados anteriormente!",
          email: "",
          discription:"",
          isError: false,
        })
      );
      history.push("/conclusao");
    } else {
      toast.warn(errorMsg, {
        position: toast.POSITION.BOTTOM_RIGHT,
        className: "ui-alert-toast",
        bodyClassName: "ui-alert-toast-content",
      });
    }
  })
  .finally(() => {
    dispatch(setLoadingPage(false));
  }) 
}
